// Fragments for Upload view extraction

import { safeCall } from '../ui/safe-cleanup.js';

// Verbatim template body moved from upload.js (lines 75-131 in original).
export function uploadTemplate() {
  return `
<section class="view-section grid grid-cols-12 gap-6 p-5 lg:p-8 reveal" role="region" aria-label="Importar Dados">
  <div class="col-span-12 bg-surface border border-outline-variant rounded-xl shadow-sm p-6" aria-label="Dropzone de upload">
    <div id="dropzone" class="border-2 border-dashed border-outline-variant rounded-xl p-8 flex flex-col items-center justify-center text-center bg-surface hover:bg-surface-container-low cursor-pointer transition-colors" role="button" tabindex="0" aria-label="Área de upload de planilha. Clique para selecionar">
      <div class="w-12 h-12 bg-surface-container-low rounded-[9999px] flex items-center justify-center mb-4">
        <span class="material-symbols-outlined text-2xl text-surface-tint" aria-hidden="true">upload_file</span>
      </div>
      <p class="text-sm font-semibold text-primary mb-1">Arraste e solte o arquivo aqui</p>
      <p class="text-xs text-on-surface-variant mb-2">ou clique para selecionar</p>
      <div class="flex gap-3 mt-2">
        <button class="px-4 py-2 bg-surface-tint text-white rounded-lg text-sm font-medium hover:bg-surface-tint-hover transition-colors" id="select-file-btn" type="button">Selecionar arquivo</button>
        <button class="px-4 py-2 text-surface-tint border border-outline-variant rounded-lg text-sm font-medium hover:bg-surface-container-low transition-colors" id="download-template-btn" type="button">Baixar modelo</button>
      </div>
      <input type="file" id="file-input" class="hidden" accept=".csv,.xlsx,.xls,.ods">
    </div>
  </div>

  <div id="upload-status" class="col-span-12 bg-surface border border-outline-variant rounded-xl shadow-sm p-5 hidden" aria-label="Status do upload">
    <div class="flex items-center justify-between mb-2">
      <span class="text-xs font-bold text-on-surface-variant uppercase">Arquivo:</span>
      <span id="filename" class="text-sm font-medium text-primary">Nenhum arquivo selecionado</span>
    </div>
    <div id="upload-info" class="text-xs text-on-surface-variant mb-3">Sem informações</div>
    <div class="flex items-center gap-2">
      <button class="px-3 py-1.5 text-xs font-medium text-surface-tint hover:bg-surface-container-low rounded-lg transition-colors" id="visualize-btn" type="button">Visualizar dados</button>
      <button class="px-3 py-1.5 text-xs font-medium text-error hover:bg-red-50 rounded-lg transition-colors" id="remove-btn" type="button">Remover</button>
      <button class="ml-auto px-3 py-1.5 text-xs font-medium bg-surface-tint text-white rounded-lg hover:bg-surface-tint-hover transition-colors" id="confirm-btn" type="button">Confirmar carregamento</button>
    </div>
  </div>

  <!-- Data schema: estrutura esperada da planilha -->
  <div class="col-span-12 text-xs text-on-surface-variant" aria-label="Estrutura esperada da planilha">
    <p class="font-bold mb-1">Estrutura esperada da planilha:</p>
    <table class="w-full text-left">
      <tr><td class="pr-4 font-medium">Torre/Bloco:</td><td>Texto (obrigatório)</td></tr>
      <tr><td class="pr-4 font-medium">Avanço Previsto %:</td><td>Número (obrigatório)</td></tr>
      <tr><td class="pr-4 font-medium">Avanço Realizado %:</td><td>Número (obrigatório)</td></tr>
      <tr><td class="pr-4 font-medium">Custo Orçado:</td><td>Número (opcional)</td></tr>
      <tr><td class="pr-4 font-medium">Custo Executado:</td><td>Número (opcional)</td></tr>
      <tr><td class="pr-4 font-medium">Responsável:</td><td>Texto (opcional)</td></tr>
    </table>
  </div>

  <div id="upload-empty" class="col-span-12 bg-surface border border-outline-variant rounded-xl shadow-sm p-6" style="display:none" aria-label="Empty state de upload">
    <div class="flex items-center gap-3 text-center mx-auto justify-center flex-col" style="max-width:420px">
      <div class="w-12 h-12 bg-surface-container-low rounded-[9999px] flex items-center justify-center mb-2">
        <span class="material-symbols-outlined text-3xl text-on-surface-variant" aria-hidden="true">cloud_upload</span>
      </div>
      <div class="text-lg font-bold text-primary">Nenhum dado importado</div>
      <p class="text-sm text-on-surface-variant text-center">Insira uma planilha (.csv, .xlsx, .xls, .ods) para começar a visualização dos dados de medição.</p>
      <button class="mt-2 px-4 py-2 bg-surface-tint text-white rounded-lg text-sm font-medium hover:bg-surface-tint-hover transition-colors" id="load-file-btn" type="button">Carregar arquivo</button>
    </div>
  </div>
</section>
`;
}

// Upload wiring: DOM events and element queries
export function wireUploadEvents(host, { showToast }) {
  // Internal refs to wire up events without inline handlers
  let dropzoneEl = null;
  let fileInputEl = null;
  let selectBtnEl = null;
  let downloadBtnEl = null;
  let statusEl = null;
let filenameEl = null;
let visualizeBtnEl = null;
  let removeBtnEl = null;
  let confirmBtnEl = null;
  let loadFileBtnEl = null;
  let emptyPanelEl = null;

  // Drag/drop helpers
  function onDragOver(e) {
    e.preventDefault();
    if (dropzoneEl) {
      dropzoneEl.classList.add('bg-primary-fixed');
    }
  }
  function onDragLeave() {
    if (dropzoneEl) {
      dropzoneEl.style.backgroundColor = '';
    }
  }
  function onDrop(e) {
    e.preventDefault();
    onDragLeave();
    const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) {
      handleFileLoaded(f.name);
      // Simulate immediate parsing/loading
      showToast('Arquivo carregado com sucesso', 'success');
    }
  }

  function onFileInputChange() {
    const f = fileInputEl && fileInputEl.files && fileInputEl.files[0];
    if (f) {
      handleFileLoaded(f.name);
      showToast('Arquivo carregado com sucesso', 'success');
    }
  }

  function handleFileLoaded(name) {
    if (!name) return;
    if (filenameEl) filenameEl.textContent = name;
    if (statusEl) statusEl.style.display = 'block';
    if (dropzoneEl) dropzoneEl.style.display = 'none';
    // Ensure empty panel is hidden when a file exists
    if (emptyPanelEl) emptyPanelEl.style.display = 'none';
  }

  function clearUpload() {
    // Reset UI back to initial state
    if (statusEl) statusEl.style.display = 'none';
    if (dropzoneEl) dropzoneEl.style.display = 'block';
    if (filenameEl) filenameEl.textContent = 'Nenhum arquivo selecionado';
    if (fileInputEl) {
      fileInputEl.value = '';
    }
    if (emptyPanelEl) emptyPanelEl.style.display = 'none';
  }

  // Template mirrors V7 Upload view
  // Note: We intentionally reuse uploadTemplate() here to render the markup
  // and then wire up event listeners to the real DOM elements.
  function render() {
    host.innerHTML = uploadTemplate();
    // grab elements for wiring
    dropzoneEl = host.querySelector('#dropzone');
    fileInputEl = host.querySelector('#file-input');
    statusEl = host.querySelector('#upload-status');
    filenameEl = host.querySelector('#filename');
    host.querySelector('#upload-info'); // info element — not referenced after init
    emptyPanelEl = host.querySelector('#upload-empty');
    selectBtnEl = host.querySelector('#select-file-btn');
    downloadBtnEl = host.querySelector('#download-template-btn');
    visualizeBtnEl = host.querySelector('#visualize-btn');
    removeBtnEl = host.querySelector('#remove-btn');
    confirmBtnEl = host.querySelector('#confirm-btn');
    loadFileBtnEl = host.querySelector('#load-file-btn');

    // Attach event listeners (delegated style, not inline handlers)
    if (dropzoneEl) {
      dropzoneEl.addEventListener('dragover', onDragOver);
      dropzoneEl.addEventListener('dragleave', onDragLeave);
      dropzoneEl.addEventListener('drop', onDrop);
      dropzoneEl.addEventListener('keydown', onDropzoneKeyDown);
    }
    if (fileInputEl) {
      fileInputEl.addEventListener('change', onFileInputChange);
    }
    if (selectBtnEl) {
      selectBtnEl.addEventListener('click', onSelectFileClick);
    }
    if (downloadBtnEl) {
      downloadBtnEl.addEventListener('click', onDownloadTemplate);
    }
    if (visualizeBtnEl) {
      visualizeBtnEl.addEventListener('click', onVisualize);
    }
    if (removeBtnEl) {
      removeBtnEl.addEventListener('click', clearUpload);
    }
    if (confirmBtnEl) {
      confirmBtnEl.addEventListener('click', onConfirm);
    }
    if (loadFileBtnEl) {
      loadFileBtnEl.addEventListener('click', onLoadFileClick);
    }
  }

  render();

  // Keyboard handler for dropzone activation
  function onDropzoneKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') fileInputEl && fileInputEl.click();
  }

  function onSelectFileClick() { if (fileInputEl) fileInputEl.click(); }
  function onDownloadTemplate() { showToast('Modelo CSV baixado', 'success'); }
  function onVisualize() { showToast('Visualização em desenvolvimento'); }
  function onConfirm() { showToast('Dados importados para o dashboard', 'success'); }
  function onLoadFileClick() { if (fileInputEl) fileInputEl.click(); }

  // Expose unmount function
  return function unmount() {
    // Best-effort: each removeEventListener is safe even if element was already GC'd
    safeCall(() => {
      if (dropzoneEl) {
        dropzoneEl.removeEventListener('dragover', onDragOver);
        dropzoneEl.removeEventListener('dragleave', onDragLeave);
        dropzoneEl.removeEventListener('drop', onDrop);
        dropzoneEl.removeEventListener('keydown', onDropzoneKeyDown);
      }
      if (fileInputEl) fileInputEl.removeEventListener('change', onFileInputChange);
      if (selectBtnEl) selectBtnEl.removeEventListener('click', onSelectFileClick);
      if (downloadBtnEl) downloadBtnEl.removeEventListener('click', onDownloadTemplate);
      if (visualizeBtnEl) visualizeBtnEl.removeEventListener('click', onVisualize);
      if (removeBtnEl) removeBtnEl.removeEventListener('click', clearUpload);
      if (confirmBtnEl) confirmBtnEl.removeEventListener('click', onConfirm);
      if (loadFileBtnEl) loadFileBtnEl.removeEventListener('click', onLoadFileClick);
    });
    host.innerHTML = '';
    host.innerHTML = '';
  };
}
